/**
 * A global namespace for `mousedown` event.
 */
const mousedownEvent = 'mousedown';
export default mousedownEvent;
